import bezier from "bezier-easing"
import { split_css_unit } from "svelte/internal"
import { fade as fadeTransition, fly as flyTransition } from "svelte/transition"
import { type BlurParams, type TransitionConfig } from "svelte/transition"

const customEaseInOut = bezier(0.5, 0, 0.5, 1)

export const easing = customEaseInOut

export const fade: typeof fadeTransition = (node, params) =>
  fadeTransition(node, {
    duration: 300,
    easing: customEaseInOut,
    ...params,
  })

export const fly: typeof flyTransition = (node, params) =>
  flyTransition(node, {
    duration: 300,
    easing: customEaseInOut,
    ...params,
  })

export const backdropBlur = (
  node: HTMLElement,
  {
    delay = 0,
    duration = 300,
    easing = customEaseInOut,
    amount = 5,
  }: Omit<BlurParams, "opacity"> = {},
): TransitionConfig => {
  const [value, unit] = split_css_unit(amount)

  let filter = "backdrop-filter"
  // Safari, https://developer.mozilla.org/en-US/docs/Web/CSS/backdrop-filter#browser_compatibility
  if (!("backdropFilter" in node.style)) filter = "-webkit-" + filter

  return {
    delay,
    duration,
    easing,
    css: (t) => `${filter}: blur(${t * value}${unit})`,
  }
}
